const BASE = import.meta.env.BASE_URL;

/**
 * A game tile image, served as WebP with the original PNG as a fallback.
 *
 * The hub loads fifteen of these at once, which was over a megabyte of PNG —
 * by far the heaviest thing on the site's most important page. The WebP copies
 * are generated from the same source art and total about a third of that.
 *
 * `name` is the file's base name without an extension, e.g. `games/cryptogram`.
 */
export default function Art({
  name,
  alt = '',
  className,
  width,
  height,
  eager = false,
}: {
  name: string;
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
  eager?: boolean;
}) {
  return (
    <picture>
      <source srcSet={`${BASE}${name}.webp`} type="image/webp" />
      <img
        className={className}
        src={`${BASE}${name}.png`}
        alt={alt}
        width={width}
        height={height}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
      />
    </picture>
  );
}
